/**
 * Darkens a CSS `rgb(r, g, b)` string by fixed per-channel offsets.
 *
 * Every toolbar icon declares `color` optional, so `undefined` reaches here whenever a caller omits
 * it. That used to hit `.replace` on `undefined` and take the whole toolbar down with a TypeError;
 * the gradient stop now inherits `currentColor` instead, which is what the sibling `stop-color`
 * already does with an absent colour.
 */
export default function ChangeColor(color: string | undefined) {
  if (color === undefined) return "currentColor";
  const channels = color.replace(/[^\d,]/g, "").split(",");
  return `rgb(${+channels[0]! - 45} , ${+channels[1]! - 49} , ${+channels[2]! - 51})`;
}
